import setValue from './setValue'
import preselectRatesAction from './preselectRates'

export const selectRoom = async (id, dispatch, { main }) => {
  const { rooms } = main

  if (Array.isArray(rooms)) {
    const updatedRooms = rooms.map((room) => {
      if (!room.active && room.id === id) {
        dispatch(setValue('selectedRate', null))
      }
      return { ...room, active: room.id === id }
    })

    dispatch(setValue('rooms', updatedRooms))

    // preselect rates
    await dispatch(preselectRatesAction(id))
  }
}

export default id => (dispatch, getState) => selectRoom(id, dispatch, getState())
